import BlogLeftSidebarContainer from "../../../../components/pages/blog/blogPage/BlogLeftSidebar";

const BlogLeftSidebar = () => {
  return <BlogLeftSidebarContainer />;
};

export default BlogLeftSidebar;
